<div class="card border-0">
  <div class="card-body">
    <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
      <h4 class="mb-0 me-auto">{{ '::UsuariosAcessos:Titulo' | abpLocalization }}</h4>
      <div class="input-group input-group-sm w-auto">
        <input
          type="search"
          class="form-control"
          [placeholder]="'::UsuariosAcessos:Buscar' | abpLocalization"
          [(ngModel)]="filtro"
          [ngModelOptions]="{ standalone: true }"
          (keyup.enter)="carregar()"
        />
        <button class="btn btn-outline-secondary" type="button" (click)="carregar()">
          <i class="fas fa-search"></i>
        </button>
      </div>
      <button class="btn btn-primary btn-sm" type="button" (click)="abrirNovo()">
        <i class="fas fa-plus me-1"></i>{{ '::UsuariosAcessos:Novo' | abpLocalization }}
      </button>
    </div>

    <p class="text-muted small">
      {{ '::UsuariosAcessos:Explicacao' | abpLocalization }}
    </p>

    <div *ngIf="carregando" class="text-center py-4">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <div *ngIf="!carregando" class="table-responsive">
      <table class="table table-hover align-middle">
        <thead>
          <tr>
            <th>{{ '::UsuariosAcessos:Usuario' | abpLocalization }}</th>
            <th>{{ '::UsuariosAcessos:Email' | abpLocalization }}</th>
            <th>{{ '::UsuariosAcessos:Situacao' | abpLocalization }}</th>
            <th class="text-end">{{ '::UsuariosAcessos:Acoes' | abpLocalization }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let usuario of usuarios">
            <td>
              <strong>{{ usuario.userName }}</strong>
              <div class="text-muted small" *ngIf="usuario.name || usuario.surname">
                {{ usuario.name }} {{ usuario.surname }}
              </div>
            </td>
            <td>{{ usuario.email }}</td>
            <td>
              <span class="badge" [class.bg-success]="usuario.isActive" [class.bg-secondary]="!usuario.isActive">
                {{ (usuario.isActive ? '::UsuariosAcessos:Ativo' : '::UsuariosAcessos:Inativo') | abpLocalization }}
              </span>
            </td>
            <td class="text-end">
              <button
                class="btn btn-sm btn-outline-primary me-1"
                type="button"
                (click)="abrirAcessos(usuario)"
                [title]="'::UsuariosAcessos:AcessosTitulo' | abpLocalization"
              >
                <i class="fas fa-key me-1"></i>{{ '::UsuariosAcessos:Acessos' | abpLocalization }}
              </button>
              <button
                class="btn btn-sm btn-outline-secondary me-1"
                type="button"
                (click)="abrirSenha(usuario)"
                [title]="'::UsuariosAcessos:SenhaTitulo' | abpLocalization"
              >
                <i class="fas fa-lock"></i>
              </button>
              <button
                *ngIf="usuario.id !== meuId"
                class="btn btn-sm"
                [class.btn-outline-danger]="usuario.isActive"
                [class.btn-outline-success]="!usuario.isActive"
                type="button"
                (click)="alternarAtivo(usuario)"
                [title]="(usuario.isActive ? '::UsuariosAcessos:Desativar' : '::UsuariosAcessos:Ativar') | abpLocalization"
              >
                <i class="fas fa-power-off"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="usuarios.length === 0">
            <td colspan="4" class="text-center text-muted py-4">
              {{ '::UsuariosAcessos:Vazio' | abpLocalization }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Novo usuário -->
<abp-modal [(visible)]="criando" [busy]="salvandoNovo">
  <ng-template #abpHeader>
    <h5>{{ '::UsuariosAcessos:NovoTitulo' | abpLocalization }}</h5>
  </ng-template>
  <ng-template #abpBody>
    <form [formGroup]="formNovo" (ngSubmit)="salvarNovo()">
      <div class="mb-2">
        <label class="form-label">{{ '::UsuariosAcessos:NomeDeUsuario' | abpLocalization }} *</label>
        <input type="text" class="form-control" formControlName="userName" autocomplete="off" />
      </div>
      <div class="row">
        <div class="col mb-2">
          <label class="form-label">{{ '::UsuariosAcessos:Nome' | abpLocalization }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
        <div class="col mb-2">
          <label class="form-label">{{ '::UsuariosAcessos:Sobrenome' | abpLocalization }}</label>
          <input type="text" class="form-control" formControlName="surname" />
        </div>
      </div>
      <div class="mb-2">
        <label class="form-label">{{ '::UsuariosAcessos:Email' | abpLocalization }} *</label>
        <input type="email" class="form-control" formControlName="email" autocomplete="off" />
      </div>
      <div class="mb-2">
        <label class="form-label">{{ '::UsuariosAcessos:SenhaProvisoria' | abpLocalization }} *</label>
        <input type="password" class="form-control" formControlName="password" autocomplete="new-password" />
        <div class="form-text">{{ '::UsuariosAcessos:SenhaProvisoriaDica' | abpLocalization }}</div>
      </div>
    </form>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" (click)="criando = false">
      {{ '::UsuariosAcessos:Cancelar' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="salvandoNovo" (click)="salvarNovo()">
      {{ '::UsuariosAcessos:Salvar' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>

<!-- Redefinir senha -->
<abp-modal [visible]="!!usuarioSenha" (visibleChange)="!$event ? (usuarioSenha = null) : null" [busy]="redefinindoSenha">
  <ng-template #abpHeader>
    <h5>{{ '::UsuariosAcessos:SenhaTitulo' | abpLocalization }} — {{ usuarioSenha?.userName }}</h5>
  </ng-template>
  <ng-template #abpBody>
    <form [formGroup]="formSenha" (ngSubmit)="salvarSenha()">
      <label class="form-label">{{ '::UsuariosAcessos:NovaSenha' | abpLocalization }} *</label>
      <input type="password" class="form-control" formControlName="novaSenha" autocomplete="new-password" />
    </form>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" (click)="usuarioSenha = null">
      {{ '::UsuariosAcessos:Cancelar' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="redefinindoSenha" (click)="salvarSenha()">
      {{ '::UsuariosAcessos:Salvar' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>

<!-- Acessos simplificados: SÓ os módulos CargoFleet contratados, com as funções de cada um -->
<abp-modal [(visible)]="acessosVisivel" [busy]="salvandoAcessos" size="lg">
  <ng-template #abpHeader>
    <h5>{{ '::UsuariosAcessos:AcessosDe' | abpLocalization }} {{ acessosUsuario?.userName }}</h5>
  </ng-template>
  <ng-template #abpBody>
    <p class="text-muted small mb-3">{{ '::UsuariosAcessos:AcessosExplicacao' | abpLocalization }}</p>

    <div *ngIf="carregandoAcessos" class="text-center py-4">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <div *ngIf="!carregandoAcessos && modulos.length === 0" class="text-center text-muted py-4">
      {{ '::UsuariosAcessos:SemModulos' | abpLocalization }}
    </div>

    <div *ngFor="let modulo of modulos" class="border rounded p-3 mb-2">
      <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          [id]="'mod-' + modulo.nome"
          [checked]="modulo.concedido"
          (change)="alternarModulo(modulo)"
        />
        <label class="form-check-label fw-semibold" [for]="'mod-' + modulo.nome">
          {{ modulo.displayName }}
        </label>
      </div>

      <div *ngIf="modulo.descricao" class="text-muted small ms-4">{{ modulo.descricao }}</div>

      <!-- Única exceção ao interruptor único: sem isto, Visibility é só acompanhar. -->
      <div *ngIf="modulo.avancarEtapa" class="form-check form-switch ms-4 mt-2">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          [id]="'fn-' + modulo.avancarEtapa.nome"
          [disabled]="!modulo.concedido"
          [(ngModel)]="modulo.avancarEtapa.concedida"
          [ngModelOptions]="{ standalone: true }"
        />
        <label class="form-check-label" [for]="'fn-' + modulo.avancarEtapa.nome">
          {{ '::UsuariosAcessos:PodeAvancarEtapa' | abpLocalization }}
        </label>
        <div class="form-text">{{ '::UsuariosAcessos:PodeAvancarEtapaDica' | abpLocalization }}</div>
      </div>
    </div>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" (click)="acessosVisivel = false">
      {{ '::UsuariosAcessos:Cancelar' | abpLocalization }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="salvandoAcessos || carregandoAcessos" (click)="salvarAcessos()">
      {{ '::UsuariosAcessos:Salvar' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
